type MicrosoftLogoProps = {
  width?: number
  height?: number
}

const MicrosoftLogo = ({ width = 20, height = 20 }: MicrosoftLogoProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      aria-hidden='true'>
      <rect x='1' y='1' width='8' height='8' fill='#F25022' />
      <rect x='11' y='1' width='8' height='8' fill='#7FBA00' />
      <rect x='1' y='11' width='8' height='8' fill='#00A4EF' />
      <rect x='11' y='11' width='8' height='8' fill='#FFB900' />
    </svg>
  )
}

export default MicrosoftLogo
